<template>
  <div>
    <!-- 参考blibli -->
    <el-card style="margin-bottom:10px"
             shadow="never">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/content_list' }">内容中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{BreadcrumbName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <!-- 参考blibli -->
    <el-card :style="bodyStyle"
             shadow="never">
      <div>
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <!-- ----------------------------------视频投稿-------------------------------------- -->

          <el-tab-pane label="视频投稿"
                       :disabled="disableVideo"
                       name="video">视频投稿</el-tab-pane>
          <!-- ----------------------------------创作图文-------------------------------------- -->

          <el-tab-pane label="创作图文"
                       :disabled="disableGraphic"
                       name="graphic">
            <!-- 编辑器 -->
            <traver-editor id="content_editor"
                           ref="traver_editor"
                           :index=0
                           :stickToolbar="300"
                           :showUnderLine="true"
                           :upLoadImgAddress="`${$ip}/add_image?key_name=content_image`"
                           @title_change="title_change"
                           @content_change="content_change"
                           :editor_content="content_form.content"
                           :content_title_prop="content_form.content_title">
              <!-- 插槽：附加内容 -->

              <div slot="addition">
                <!-- 内容摘要 -->
                <div class="addition-block">
                  <p class="title-mini">请添加内容摘要：</p>

                  <el-input style="width:50%"
                            type="textarea"
                            :rows="2"
                            resize="none"
                            :show-word-limit="true"
                            maxlength="40"
                            placeholder="请输入摘要"
                            v-model="content_form.introduce">
                  </el-input>
                </div>
                <!-- 添加-目的地 -->
                <div class="addition-block">
                  <p class="title-mini">内容所属目的地：</p>

                  <select-dest ref="traver_select_dest"
                               :destShowBack="content_form.dest"
                               @selectDest="selectDest"></select-dest>
                </div>
                <!-- 添加头图 -->
                <!-- 大于 960*540 -->
                <div class="addition-block">
                  <p class="title-mini">添加头图（选填:建议960*540）：</p>
                </div>
                <up-load-img :default_image="content_form.title_image"
                             dialogName="图片剪裁"
                             @getCroperImageURl="getCroperTitleImage"
                             imageWidth="192px"
                             imageHeight="108px"
                             keyName="test_upload"
                             :limitSize="8"
                             :fixedRatio="[192, 108]"></up-load-img>
                <!-- 添加封面 -->
                <div class="addition-block">
                  <p class="title-mini">请添加封面图（最小尺寸：960*600）：</p>

                </div>
                <up-load-img :default_image="content_form.cover_image"
                             @getCroperImageURl="getCroperAvaterImage"
                             dialogName="封面图剪切"
                             imageWidth="192px"
                             imageHeight="160px"
                             :limitSize="8"
                             :fixedRatio="[192, 160]"></up-load-img>

                <!-- 添加标签 -->
                <div class="addition-block">
                  <p class="title-mini">请添加标签：</p>

                  <select-tag ref="select_tag"
                              :tagList="contentTags"
                              @getSelectList="getSelectList"
                              @addNewTagToTagList="addNewTagToTagList"></select-tag>
                </div>
              </div>
              <!-- 插槽-提交- 按钮 -->
              <div slot="button">
                <el-button @click="submitContent"
                           size="mini"
                           type="primary">提交内容</el-button>
              </div>
            </traver-editor>
          </el-tab-pane>
          <!-- ----------------------------------音频投稿-------------------------------------- -->
          <el-tab-pane label="音频投稿"
                       :disabled="disableAudio"
                       name="audio">音频投稿</el-tab-pane>

        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
import Editor from '../../components/common/editor/editorV2artical'
import UpLoad from '../../components/common/other/UpLoadV2Croper'
import SelectTag from '../../components/common/select/SelectTag'
import SelectDest from '../../components/common/select/SelectDest'

export default {
  name: 'creat-content',
  components: {
    'traver-editor': Editor,
    'up-load-img': UpLoad,
    'select-tag': SelectTag,
    'select-dest': SelectDest,
  },
  data() {
    return {
      BreadcrumbName: '创建内容',
      disableVideo: false,
      disableGraphic: false,
      disableAudio: false,
      activeName: 'graphic',
      bodyStyle: `min-height: ${contentHeight}px`,
      contentTags: [], // 全部标签
      // 创作图文：上传表单
      content_form: {
        dest: null,
        content_title: '',
        content: '',
        title_image: '',
        cover_image: '',
        introduce: '',
        tag_list: [], // 已选标签
        content_type: '',
      },
    }
  },
  mounted() {
    this.getAllContentTag()
    // console.log(this.$route.params)
  },
  methods: {
    // ------------------------创建图文内容------------------------
    handleClick() {},
    // 监听选择目的地
    selectDest(dest) {
      this.content_form.dest = dest
    },
    // 监听标题变化
    title_change(title) {
      this.content_form.content_title = title
    },
    // 监听编辑器内容变化
    content_change(content) {
      this.content_form.content = content
    },
    getSelectList(value) {
      // console.log(value)
      let selectList = []
      value.forEach((i) => {
        selectList.push(i.tag_id)
      })
      this.content_form.tag_list = selectList
    },
    // 获取图片链接
    getCroperAvaterImage(value) {
      this.content_form.cover_image = value
    },
    getCroperTitleImage(value) {
      this.content_form.title_image = value
    },
    // 提交内容
    submitContent() {
      // console.log(this.content_form)
      this.content_form.content_type = this.activeName
      this.$http
        .post('/traver/add_content_graphic', this.content_form)
        .then((res) => {
          // console.log(res)
          const { errno, errmsg } = res.data
          if (errno == '0') {
            // 创建成功，跳转路由
            this.$router.push({ path: '/content_list' })
          } else {
            this.$message({
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    // 获取所有内容标签
    getAllContentTag() {
      this.$http.get('/traver/get_content_tag').then((res) => {
        const { errno, errmsg, tag_list } = res.data
        if (errno == '0') {
          this.contentTags = tag_list
          // console.log(this.contentTags)
        } else {
          this.$message({
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 添加新标签
    addNewTagToTagList(value) {
      this.$http
        .get(`/traver/add_content_tag?tag_name=${value}`)
        .then((res) => {
          const { errno, errmsg, tag } = res.data
          if (errno == '0') {
            this.contentTags.push(tag)
          } else {
            this.$message({
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
  },
}
</script>

<style>
.addition-block {
  margin-top: 20px;
}
.title-mini {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bolder;
}
#content_editor .editor-v2-artical .quill-editor {
  /* background-color: darkgray; */
  height: 500px;
}
</style>